import { setRequestHandler } from "@faire/web-api--source";
export var configure = function(options) {
    setRequestHandler(options.requestHandler);
};
